<template>
  <div>
    <el-dialog
      :title="`批量编辑  (您正在同时编辑${currentSelect.length}条${level == 'adset' ? '广告组' : '广告'})`"
      :visible="batchEditShow"
      width="80%"
      @close="close"
      @open="openInit"
      append-to-body
      :close-on-click-modal="false"
      v-dialog-drag
      class="editDialog"
    >
      <div
        class="editCon"
        v-loading="loading"
      >
        <div class="leftList">
          <choose-list
            :list="treeList"
            @setSelectList="setSelectList"
            :defaultSelect="currentSelect"
            v-if="selectList.length"
            :currentLevel="level"
            :mediaTypeMap="mediaTypeMap"
            :invaild_insterest="statusData ? statusData.invaild_insterest : []"
            ref="chooseList"
          ></choose-list>
        </div>
        <!-- <div class="rightCon" v-if=" allList.length && currentLevel == 'campaign'">
                    <ad-series  :currentSelect="currentSelect" :baseData="[...allList]" v-if="batchEditShow" :updateList='updateAdSeriesData' ref="campaign" @setCampaignData="setCampaignData" v-loading="load" labelWidth="140px"></ad-series>
                </div> -->
        <div
          class="rightCon"
          v-if="adSetList.length && currentLevel == 'adset' && currentSelect.length"
        >
          <targeting
            :currentSelect="currentSelect"
            :baseData="[...adSetList]"
            v-if="batchEditShow"
            :updateList="upadteAdSetData"
            @setData="setData"
            ref="targeting"
            v-loading="load"
            :account="accountId"
            :load="load"
            @setBaseName="setBaseName"
            :targetUserId="currentRowNum"
            :statusDataItem.sync="statusData"
            :edit="true"
            :advancedStatus="advancedStatus"
          ></targeting>
        </div>
        <div
          class="rightCon"
          v-if="adList.length && currentLevel == 'ad' && currentSelect.length"
        >
          <creative
            :currentSelect="currentSelect"
            :baseData="[...adList]"
            v-if="batchEditShow"
            :updateList="updateAdData"
            ref="creative"
            @setAdData="setAdData"
            v-loading="load"
            :account="accountId"
            @setBaseName="setBaseName"
            :targetUserId="currentRowNum"
            :edit="true"
          ></creative>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          v-if="flag"
          id="bacthEditEvent"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="tryAgain"
          v-if="!flag"
          >重 试</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import chooseList from './chooseList.vue';
import targeting from './adset/targeting';
import creative from './ads/creative';
import adSeries from './campaign/adSeries';
import initData from './initData';
import {
  batchFetchAdSet,
  batchUpdateAdSet,
  batchFetchAd,
  batchUpdateAd,
  batchEditFetch,
  batchEdit,
} from '@/api/adManagement';
import { accountPages, saleSearch } from '@/api/creatAd';
import { domainReg } from '@/utils/utils';
import tools from '../../createAd/components/tools';
import { confirmFacebookHighBid } from '@/utils/facebookBidConfirm';
export default {
  components: { chooseList, targeting, creative, adSeries },
  props: ['batchEditShow', 'list', 'initCreatAdData', 'level'],
  mixins: [initData, tools],
  data() {
    return {
      selectList: [], //选择的广告组
      currentSelect: [], //选中的广告组
      baseData: [], //所有选择的广告的基本信息
      upadteData: [], //要保存的所有的广告组的信息
      pageList: [], //账户主页
      adSetList: [],
      treeList: [],
      adList: [],
      parentSelectList: [],
      currentLevel: this.level,
      upadteAdSetData: [],
      updateAdData: [],
      flag: true,
      saveMsgList: [],
      resultStatus: [],
      load: false,
      timer: null,
      loading: false,
      campaignList: [],
      updateAdSeriesData: [],
      allList: [],
      statusData: {},
      // 以 campaign_id 为 key 缓存每个系列的进阶状态
      campaignAdvancedStatusCache: {},
    };
  },
  computed: {
    // 多账号 currentNum 当前个号
    currentRowNum() {
      return this.list && this.list.length && this.list[0].rowThirdNum ? this.list[0].rowThirdNum : this.selectNum;
    },
    accountId() {
      return this.list && this.list.length && this.list[0].rowAccountId
        ? this.list[0].rowAccountId
        : this.$store.getters.accountId;
    },
    mediaTypeMap() {
      let obj = {};
      this.updateAdData.forEach((item) => {
        obj[item.id] = {
          media_type: item.creative.media_type,
          videoStatus: item.creative.videoStatus,
          videoId: item.creative.videoId,
          thumbUrl: item.creative.thumbUrl,
          // 进阶创意需要传递fbAssetFeedSpec
          fbAssetFeedSpec: item.creative.fbAssetFeedSpec,
        };
      });
      console.log(obj);
      return obj;
    },
    // 进阶状态计算属性
    advancedStatus() {
      if (this.currentSelect.length !== 1) {
        return {
          isAdvancedBudget: false,
          isAdvancedPlacement: false,
          isAdvancedAudience: false,
        };
      }
      const currentData = this.upadteAdSetData.find((v) => v.id === this.currentSelect[0]);
      if (!currentData) {
        return {
          isAdvancedBudget: false,
          isAdvancedPlacement: false,
          isAdvancedAudience: false,
        };
      }

      const campaignId = currentData.campaign_id;

      // 优先从缓存获取该系列的进阶状态
      const cachedStatus = this.campaignAdvancedStatusCache[campaignId];
      if (cachedStatus) {
        return cachedStatus;
      }

      // 无缓存时使用接口返回的初始值
      return {
        isAdvancedBudget: !!currentData.isAdvantageBudget,
        isAdvancedPlacement: !!currentData.isAdvantagePlacement,
        isAdvancedAudience: !!currentData.isAdvantageAudience,
      };
    },
  },
  created() {
    // if(this.level == 'ad'){
    //     this.getAccountPage()
    // }
  },
  watch: {
    initCreatAdData: {
      handler() {
        this.init = this.initCreatAdData;
      },
    },
    statusData: {
      deep: true,
      handler(val) {
        console.log('---------12', val);
      },
    },
  },
  methods: {
    setBaseName(level, id, name) {
      console.log(level);
      if (level == 'campaign') {
        this.allList.map((campaign, index) => {
          if (id == campaign.id) {
            this.allList[index].name = name;
          }
        });
      }
      if (level == 'adset') {
        this.adSetList.map((adset, i) => {
          if (adset.id == id) {
            this.adSetList[i].name = name;
          }
        });
        this.treeList.forEach((campaign) => {
          (campaign.children || []).forEach((adset) => {
            if (adset.id == id) {
              adset.name = name;
            }
          });
        });
        // this.allList.map((campaign,index)=>{
        //     adSetList.list.map((adset,i)=>{
        //         if(adset.id == id){
        //             this.allList[index].list[i].name = name
        //         }
        //     })
        // })
        this.upadteAdSetData.map((adset, index) => {
          if (adset.id == id) {
            adset.name = name;
          }
        });
      }
      if (level == 'ad') {
        console.log(this.adSetList);
        this.adSetList.map((ad, ind) => {
          if (ad.id == id) {
            this.adSetList.list[ind].name = name;
          }
        });
        // this.allList.map((campaign,index)=>{
        //     campaign.list.map((adset,i)=>{
        //         adset.list.map((ad,ind)=>{
        //             if(ad.id == id){
        //                 this.allList[index].list[i].list[ind].name = name
        //             }
        //         })
        //     })
        // })
      }
    },
    // 获取账户主页
    async getAccountPage(v) {
      console.log(v);
      await accountPages({ accountId: this.accountId, force: v }).then((res) => {
        let canUse = res.data.filter((v) => v.is_published);
        let notUse = res.data.filter((v) => !v.is_published);
        this.pageList = canUse.concat(notUse);
        if (v) {
          this.$message('更新成功');
        }
      });
    },
    close() {
      if (this.$refs['creative']) {
        this.$refs['creative'].cancleGetbatchVideoStatus = true;
      }
      this.$emit('update:batchEditShow', false);
      this.selectList = [];
      this.baseData = [];
      this.adSetList = [];
      this.treeList = [];
      this.adList = [];
      this.currentLevel = '';
      // 清空缓存
      this.campaignAdvancedStatusCache = {};
    },
    openInit() {
      console.log(this.list);
      this.currentLevel = this.level;
      this.selectList = JSON.parse(JSON.stringify(this.list));
      this.currentSelect = JSON.parse(JSON.stringify(this.list)).map((v) => v.id);
      this.getAccountPage();
      console.log(this);
      // if(this.level == 'adset'){
      //     this.getAdsetList();
      // }
      // if(this.level == 'ad'){
      //     this.getAdsList();
      // }
      this.getList();
    },
    getAdsList() {
      batchFetchAd({ adIds: this.list.map((v) => v.id), accountId: this.accountId }).then((res) => {
        if (res.code == 0) {
          this.baseData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    getAdsetList() {
      batchFetchAdSet({ adSetIds: this.list.map((v) => v.id) }).then((res) => {
        this.baseData = JSON.parse(JSON.stringify(res.data));
        this.baseData.map((v) => {
          if (v.targeting[0].exclusions) {
            v.targeting[0].exclusions = [v.targeting[0].exclusions];
          } else {
            v.targeting[0].exclusions = [];
          }
          if (v.targeting[0].flexible_spec) {
            v.targeting[0].flexible_spec = v.targeting[0].flexible_spec.length ? v.targeting[0].flexible_spec : [];
          }
          if (v.targeting[0].genders.length == 2) {
            v.targeting[0].genders = 'all';
          } else {
            v.targeting[0].genders = v.targeting[0].genders[0];
          }
          console.log(v.targeting[0].genders);
        });
        this.baseData = JSON.parse(JSON.stringify(this.baseData));
        // this.$store.commit('initData/setBaseData',this.baseData)
        // console.log(this.$store.getters.baseData);
      });
    },
    // 获取组合信息
    getList() {
      let obj_type = this.level == 'ad' ? 'AD' : 'ADSET';
      this.loading = true;
      console.log(this.list);
      batchEditFetch(
        { obj_type: obj_type, account_id: this.accountId, obj_ids: this.list.map((v) => v.id) },
        this.currentRowNum,
      ).then(async (res) => {
        this.loading = false;
        if (res.code !== 0) {
          this.campaignList = [];
          this.adSetList = [];
          this.treeList = [];
          this.adList = [];
          return false;
        }
        let adList = [];
        let adSetList = [];
        let treeList = [];
        let campaigns = JSON.parse(JSON.stringify(res.data || []));
        let saleList = [];
        const uniqueSaleIds = this.extractUniqueSaleIds(campaigns);
        if (uniqueSaleIds.length > 0) {
          saleList = await this.handelSaleSearch(uniqueSaleIds);
        }
        campaigns.forEach((campaign) => {
          const treeAdsets = [];
          (campaign.adsets || []).forEach((v) => {
            v.level = 'adset';
            v.is_cbo = v.cbo;
            v.ads = v.ads || [];
            v.targeting[0].targeting_automation = v.targeting[0].targeting_automation || {
              advantage_audience: 0,
            };
            const dp = v.targeting[0].device_platforms;
            v._initialAdvantageAudience = v.targeting[0].targeting_automation?.advantage_audience === 1;
            v._initialAdvantagePlacement = !dp || dp.length === 0;
            if (v.targeting[0].exclusions) {
              v.targeting[0].exclusions = [v.targeting[0].exclusions];
            } else {
              v.targeting[0].exclusions = [];
            }
            if (v.targeting[0].flexible_spec) {
              v.targeting[0].flexible_spec = v.targeting[0].flexible_spec.length ? v.targeting[0].flexible_spec : [];
            }
            if (v.targeting[0].genders && v.targeting[0].genders.length == 2) {
              v.targeting[0].genders = 'all';
            } else {
              v.targeting[0].genders = v.targeting[0].genders ? v.targeting[0].genders[0] : '';
            }
            v.ads.forEach((k) => {
              k.level = 'ad';
              k.objective = v.campaignObjective;
              k.creative = JSON.parse(JSON.stringify(k.adcreative));
              if (saleList && saleList.length) {
                const item = saleList.find((sale) => sale.saleId == k.creative.saleId);
                k.creative.langId = item ? item.langId : '';
                k.creative.productId = item ? item.productId : '';
              }
            });
            adList = adList.concat(v.ads);
            adSetList.push(v);
            treeAdsets.push({
              id: v.id,
              name: v.name,
              level: 'adset',
              children: v.ads.map((ad) => ({
                id: ad.id,
                name: ad.name,
                level: 'ad',
                objective: ad.objective,
                creative: ad.creative,
              })),
            });
          });
          treeList.push({
            id: campaign.id,
            name: campaign.name || '',
            level: 'campaign',
            children: treeAdsets,
          });
        });
        if (this.level == 'ad') {
          const returnedIds = new Set(adList.map((ad) => String(ad.id)));
          const missing = (this.list || []).filter((row) => !returnedIds.has(String(row.id)));
          if (missing.length) {
            this.$message({
              type: 'warning',
              message: '部分广告未查到',
            });
          }
        }
        this.treeList = treeList;
        this.adSetList = adSetList;
        this.adList = adList;
        let listSelect = adList.filter((v) => this.selectList.includes(v.id));
        if (
          listSelect.filter((v) => v.creative.media_type !== 'asset_feed').length &&
          listSelect.filter((v) => v.creative.media_type == 'asset_feed').length
        ) {
          this.$message({
            type: 'warning',
            message: '动态广告与其他广告不能同时编辑',
          });
          this.selectList = [];
          this.currentSelect = [];
        }
        // this.campaignList = list
        this.upadteAdSetData = JSON.parse(JSON.stringify(adSetList));
        this.updateAdData = JSON.parse(JSON.stringify(adList));
        // 初始化每个系列的进阶状态缓存
        this.initCampaignAdvancedStatusCache(adSetList);
        // 初始化时根据当前 level 触发 selectAll，确保只选择一种广告分类
        this.$nextTick(() => {
          this.$refs.chooseList?.initSelectAll();
        });
        // this.updateAdSeriesData = JSON.parse(JSON.stringify(list));
        // console.log(this.campaignList);
      });
    },
    // 初始化每个系列的进阶状态缓存
    initCampaignAdvancedStatusCache(adSetList) {
      const cache = {};
      // 按 campaign_id 分组
      const campaignGroups = {};
      adSetList.forEach((adset) => {
        const campaignId = adset.campaign_id;
        if (!campaignId) return;
        if (!campaignGroups[campaignId]) {
          campaignGroups[campaignId] = [];
        }
        campaignGroups[campaignId].push(adset);
      });

      // 为每个系列计算初始进阶状态
      Object.keys(campaignGroups).forEach((campaignId) => {
        const adsets = campaignGroups[campaignId];
        const firstAdset = adsets[0];

        // 使用接口返回的初始值
        cache[campaignId] = {
          isAdvancedBudget: !!firstAdset.isAdvantageBudget,
          isAdvancedAudience: !!firstAdset.isAdvantageAudience,
          isAdvancedPlacement: !!firstAdset.isAdvantagePlacement,
        };
      });

      this.campaignAdvancedStatusCache = cache;
    },
    setSelectList(v, level) {
      console.log('-----1-21212', v, level);
      this.timer = null;
      this.load = true;
      this.currentSelect = v;
      this.currentLevel = level;
      setTimeout(this.interval, 500);
      // this.$store.commit('initData/setCurrentSelect',v)
    },
    interval() {
      this.load = false;
    },
    setData(v) {
      this.upadteAdSetData = JSON.parse(JSON.stringify(v));
      console.log(this.upadteAdSetData);
      // 数据更新后，更新当前系列的进阶状态缓存
      this.updateCampaignAdvancedStatusCache();
    },
    // 更新当前系列的进阶状态缓存
    updateCampaignAdvancedStatusCache() {
      if (this.currentSelect.length !== 1) return;
      const currentData = this.upadteAdSetData.find((v) => v.id === this.currentSelect[0]);
      if (!currentData?.campaign_id) return;

      const campaignId = currentData.campaign_id;
      const sameCampaignAdsets = this.upadteAdSetData.filter((v) => v.campaign_id === campaignId);
      const isSingleAdset = sameCampaignAdsets.length === 1;

      // 重新计算进阶状态
      let isAdvancedBudget = !!currentData.cbo || isSingleAdset;

      const isAdvancedAudience = sameCampaignAdsets.some(
        (adset) => adset.targeting?.[0]?.targeting_automation?.advantage_audience === 1,
      );

      const isAdvancedPlacement = sameCampaignAdsets.every((adset) => {
        const dp = adset.targeting?.[0]?.device_platforms;
        return !dp || dp.length === 0;
      });

      // 更新缓存
      this.campaignAdvancedStatusCache[campaignId] = {
        isAdvancedBudget,
        isAdvancedAudience,
        isAdvancedPlacement,
      };
    },
    setAdData(v) {
      this.updateAdData = JSON.parse(JSON.stringify(v));
    },
    setCampaignData(v) {
      this.updateAdSeriesData = JSON.parse(JSON.stringify(v));
    },
    saveAdset() {
      console.log(this.$refs.targeting.baseData);
      let list = JSON.parse(JSON.stringify(this.$refs.targeting.listData));
      list.map((v) => {
        v.targeting[0].genders = v.targeting[0].genders === 'all' ? ['M', 'F'] : [v.targeting[0].genders];
        v.targeting[0].exclusions =
          v.targeting[0].exclusions && v.targeting[0].exclusions.length ? v.targeting[0].exclusions[0] : null;
      });
      this.$showLoading();
      batchUpdateAdSet({ adsetForUpdate: list }).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.comment,
          });
          this.$emit('get-list');

          this.close();
        }
        this.$hideLoading();
      });
    },
    saveAdCreative() {
      let list = JSON.parse(JSON.stringify(this.$refs.creative.listData));
      if (list.some((v) => v.adcreative.show_url && !/^(\w+\.)+\w+$/.test(v.adcreative.show_url))) {
        this.$message({
          type: 'warning',
          message: '请输入正确的显示链接',
        });
        return false;
      }
      let flag = true;
      list.map((v) => {
        if (v.adcreative.media_type == 'muti') {
          v.adcreative.mutiImgs.map((key, index) => {
            delete key.name;
            delete key.fixed;
            if (!key.image) {
              v.adcreative.mutiImgs.splice(index, 1);
            }
            if (v.adcreative.mutiImgs.length < 2) {
              flag = false;
            }
          });
        }
      });
      if (!flag) {
        this.$message({
          type: 'warning',
          message: '轮播图请至少上传2张图片',
        });
        return false;
      }
      this.$showLoading();
      batchUpdateAd({ adForBatches: list }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.comment,
          });
          this.$emit('get-list');

          this.close();
        }
        this.$hideLoading();
      });
    },
    // 处理受众
    editFlex(list) {
      if (!list) return null;
      console.log(list);
      list.map((v, i) => {
        let flag = false;
        for (let key in v) {
          if (v[key] && v[key].length) {
            flag = true;
          }
        }
        if (!flag) {
          list.splice(i, 1);
        }
      });
      return list.length ? list : null;
    },
    async saveList() {
      let adsetList = this.upadteAdSetData.length
        ? JSON.parse(JSON.stringify(this.upadteAdSetData))
        : JSON.parse(JSON.stringify(this.adSetList));
      let baseList = JSON.parse(JSON.stringify(this.adSetList));
      if (
        adsetList.some(
          (v) =>
            v.targeting[0].excluded_geo_locations_places &&
            v.targeting[0].excluded_geo_locations_places.length &&
            !v.targeting[0].excluded_geo_locations_place_radius,
        )
      ) {
        this.$message({
          type: 'warning',
          message: '请填写排除城镇公里数',
        });
        return false;
      }
      if (
        adsetList.some(
          (v) =>
            !(
              (v.targeting[0].geo_locations && v.targeting[0].geo_locations.length) ||
              (v.targeting[0].geo_locations_region && v.targeting[0].geo_locations_region.length) ||
              (v.targeting[0].geo_locations_city && v.targeting[0].geo_locations_city.length)
            ),
        )
      ) {
        this.$message({
          type: 'warning',
          message: '请选择受众地区',
        });
        return false;
      }
      adsetList.map((v) => {
        delete v.ads;
        v.targeting[0].geo_locations =
          v.targeting[0].geo_locations && v.targeting[0].geo_locations.length ? v.targeting[0].geo_locations : null;
        v.targeting[0].excluded_geo_locations =
          v.targeting[0].excluded_geo_locations && v.targeting[0].excluded_geo_locations.length
            ? v.targeting[0].excluded_geo_locations
            : null;
        v.targeting[0].geo_locations_city =
          v.targeting[0].geo_locations_city && v.targeting[0].geo_locations_city.length
            ? v.targeting[0].geo_locations_city
            : null;
        v.targeting[0].geo_locations_region =
          v.targeting[0].geo_locations_region && v.targeting[0].geo_locations_region.length
            ? v.targeting[0].geo_locations_region
            : null;
        v.targeting[0].flexible_spec = this.editFlex(v.targeting[0].flexible_spec);
        baseList.map((k) => {
          delete k.ads;
          if (v.id == k.id) {
            let obj = JSON.parse(JSON.stringify(v));
            delete obj.ads;
            delete obj.status;
            v.changed = !(JSON.stringify(obj) == JSON.stringify(k));
          }
        });
        v.targeting[0].genders =
          v.targeting[0].genders === 'all' ? ['M', 'F'] : v.targeting[0].genders ? [v.targeting[0].genders] : null;
        v.targeting[0].exclusions =
          v.targeting[0].exclusions && v.targeting[0].exclusions.length ? v.targeting[0].exclusions[0] : null;
      });
      let adList = this.updateAdData.length
        ? JSON.parse(JSON.stringify(this.updateAdData))
        : JSON.parse(JSON.stringify(this.adList));
      adList.map((v) => (v.adcreative = JSON.parse(JSON.stringify(v.creative))));
      if (adList.some((v) => v.adcreative.show_url && !/^(\w+\.)+\w+$/.test(v.adcreative.show_url))) {
        this.$message({
          type: 'warning',
          message: '请输入正确的显示链接',
        });
        return false;
      }
      // if(adList.some(v=> !v.conversion_domain)){
      //     this.$message({
      //         type:'warning',
      //         message:'请输入正确的网域'
      //     })
      //     return false;
      // }
      let flag = true,
        assetFlag = true,
        videoFlag = true;
      adList.forEach((v) => {
        // 目录广告：coverImages 转换为 childAttachments / catalogAssetFeedSpec.images
        if (v.adcreative.media_type == 'catalog' && v.adcreative.templateData) {
          const tpl = v.adcreative.templateData;
          if (tpl.formatType === 'single') {
            tpl.forceSingleLink = true;
            tpl.multiShareEndCard = null;
            tpl.formatOption = null;
          } else if (tpl.formatType === 'collection') {
            v.adcreative.catalogAssetFeedSpec = {
              ...(v.adcreative.catalogAssetFeedSpec || {}),
              optimization_type: 'FORMAT_AUTOMATION',
              ad_formats: ['CAROUSEL', 'COLLECTION'],
            };
            tpl.multiShareEndCard = true;
            tpl.forceSingleLink = null;
            tpl.formatOption = null;
            if (tpl.coverImages && tpl.coverImages.length > 0) {
              v.adcreative.catalogAssetFeedSpec.images = tpl.coverImages.map(img => ({
                hash: img.imageHash || '',
                url: img.url || '',
                source_id: img.sourceId || '',
              }));
            }
          } else if (tpl.formatType === 'carousel') {
            tpl.multiShareEndCard = false;
            tpl.forceSingleLink = null;
            if (tpl.creativeOption === 'slideshow') {
              tpl.formatOption = 'carousel_slideshows';
            } else {
              tpl.formatOption = 'carousel_images_multi_items';
            }
            // 轮播模式：构建 bodies（message 可能是数组，来自批量编辑的正文组件）
            const messageArr = Array.isArray(tpl.message) ? tpl.message.filter(t => t && t.trim()) : (tpl.message ? [tpl.message] : []);
            if (messageArr.length > 0) {
              tpl.message = messageArr[0]; // templateData.message 只存第一条
            }
            if (messageArr.length > 1) {
              const bodies = messageArr.map(t => ({ text: t.trim() }));
              const dofSpec = {
                ...(v.adcreative.catalogAssetFeedSpec || {}),
                optimization_type: 'DEGREES_OF_FREEDOM',
                bodies: bodies,
              };
              if (tpl.description && tpl.description.trim()) {
                dofSpec.descriptions = [{ text: tpl.description.trim() }];
              }
              v.adcreative.catalogAssetFeedSpec = dofSpec;
            } else {
              v.adcreative.catalogAssetFeedSpec = {
                ...(v.adcreative.catalogAssetFeedSpec || {}),
                optimization_type: 'FORMAT_AUTOMATION',
                ad_formats: ['CAROUSEL', 'COLLECTION'],
                bodies: null,
                descriptions: null,
              };
            }
            if (tpl.coverImages && tpl.coverImages.length > 0) {
              const staticCards = tpl.coverImages.map(img => ({
                link: tpl.link || '',
                url: img.url,
                source_id: img.sourceId || '',
                image_hash: img.imageHash || '',
                name: tpl.staticCardName || '',
                description: tpl.staticCardDescription || '',
                call_to_action_type: tpl.callToActionType || 'SHOP_NOW',
                static_card: true,
              }));
              const existingDynamic = (tpl.childAttachments || []).filter(ca => !ca.static_card && !ca.staticCard);
              tpl.childAttachments = [...staticCards, ...existingDynamic];
            }
          }
          delete tpl.formatType;
          delete tpl.creativeOption;
          delete tpl.coverImages;
          delete tpl.messageVariants;
          delete tpl.enableTextGeneration;
          delete tpl.staticCardName;
          delete tpl.staticCardDescription;
        }
        if (v.adcreative.media_type == 'muti') {
          v.adcreative.mutiImgs.forEach((key, index) => {
            delete key.name;
            delete key.fixed;
            if (!key.image) {
              v.adcreative.mutiImgs.splice(index, 1);
            }
            if (v.adcreative.mutiImgs.length < 3) {
              flag = false;
            }
          });
        }
        if (v.adcreative.media_type == 'asset_feed') {
          let fbAssetFeedSpec = v.adcreative.fbAssetFeedSpec;
          let imgList = fbAssetFeedSpec.imgList || [];
          let videos = fbAssetFeedSpec.videos || [];
          let list = imgList.concat(videos);
          if (
            !fbAssetFeedSpec.mAdFormats.length ||
            !list.length ||
            !fbAssetFeedSpec.titles.length ||
            !fbAssetFeedSpec.mDescriptions.length ||
            !fbAssetFeedSpec.mBodies.length ||
            !fbAssetFeedSpec.actionTypes.length ||
            !fbAssetFeedSpec.linkUrls.length
          ) {
            assetFlag = false;
          }
          // return this.previewBefore(fbAssetFeedSpec);
          if (!this.previewBefore(fbAssetFeedSpec)) {
            return false;
          }
        }
        if (v.adcreative.media_type == 'video') {
          // 进阶创意模式下，检查fbAssetFeedSpec.videos中的封面
          if (v.adcreative.isAdvancedCreative && v.adcreative.fbAssetFeedSpec?.videos?.length) {
            const hasInvalidVideo = v.adcreative.fbAssetFeedSpec.videos.some(
              (video) => !video.thumbUrl || video.videoStatus === 'processing',
            );
            if (hasInvalidVideo) {
              videoFlag = false;
            }
          } else if (!v.adcreative.thumbUrl || v.adcreative.videoStatus == 'processing') {
            // 非进阶创意模式
            videoFlag = false;
          }
        }
      });
      if (!flag) {
        this.$message({
          type: 'warning',
          message: '轮播图请至少上传三张图片',
        });
        return false;
      }
      if (!assetFlag) {
        this.$message({
          type: 'warning',
          message: '动态素材不完整',
        });
        return false;
      }
      if (!videoFlag) {
        this.$message({
          type: 'warning',
          message: '请检查视频封面是否上传',
        });
        return false;
      }
      let baseAds = JSON.parse(JSON.stringify(this.adSetList));
      // 比对广告信息是否完全一样
      adList.map((m) => {
        baseAds.map((v) => {
          if (v.id == m.adSetId) {
            v.ads.map((k) => {
              if (k.id == m.id) {
                let obj = JSON.parse(JSON.stringify(m));
                delete obj.status;
                m.changed = !(JSON.stringify(obj) == JSON.stringify(k));
              }
            });
          }
        });
      });
      // 给每个广告组加上ads字段
      adsetList.map((v) => {
        v.ads = [];
      });
      // 把广告放到广告组里
      adList.map((k) => {
        adsetList.map((m) => {
          if (m.id == k.adSetId) {
            m.ads.push(k);
          }
        });
      });
      this.saveMsgList = JSON.parse(JSON.stringify(adsetList));
      const highBidItems = adsetList.map((item) => ({
        platform: 'facebook',
        bidStrategy: item.bid_strategy,
        amount: item.bid_amount ? this.$store.getters.toFormatedMoney(item.bid_amount).value : null,
        name: item.name,
        id: item.id,
        currencySymbol: '$',
      }));
      try {
        await confirmFacebookHighBid(this, highBidItems);
      } catch (error) {
        return;
      }
      this.saveMethods(adsetList);
    },
    saveMethods(list) {
      this.$showLoading();
      batchEdit({ adSetForBatchEdits: list, account_id: this.accountId }, this.currentRowNum).then((res) => {
        this.$hideLoading();
        console.log(res);
        if (res.code == 0) {
          this.messageTost(res.data.filter((v) => v.obj_status == 'fail'));
        }
      });
    },
    // 失败消息提示
    messageTost(list) {
      if (!list.length) {
        this.$message({
          type: 'success',
          message: '修改成功',
        });
        this.$emit('get-list');
        this.close();
        this.flag = true;
        return false;
      } else {
        this.$message({
          type: 'error',
          message: '存在保存失败的选项，请点击重试，或者忽略',
        });
        this.flag = false;
        this.resultStatus = list;
      }

      // list.map(v=>{
      //     // if(v.obj_status == 'success'){
      //     //     console.log(v);
      //     //     this.$notify({
      //     //         title: '成功',
      //     //         message:   `${v.level == 'ADSET'?'广告组':v.level == 'AD'?'广告':''}: ${v.obj_name} 保存成功`,
      //     //         type: 'success',
      //     //         position: 'bottom-right'
      //     //     });
      //     // }else{
      //     //     this.$notify.error({
      //     //         title: `${v.level == 'ADSET'?'广告组':v.level == 'AD'?'广告':''}: ${v.obj_name} 保存失败`,
      //     //         message: v.result_msg,
      //     //         duration: 0,
      //     //         position: 'bottom-right'
      //     //     });
      //     // }
      // })
    },
    tryAgain() {
      this.resultStatus.map((v) => {
        if (v.obj_level == 'ADSET') {
          this.saveMsgList.map((k) => {
            if (v.obj_status == 'success' && k.id == v.obj_id) {
              k.changed = false;
            }
          });
        } else if (v.obj_level == 'AD') {
          this.saveMsgList.map((k) => {
            k.ads.map((m) => {
              if (m.id == v.obj_id) {
                m.changed = false;
              }
            });
          });
        }
      });
      console.log(this.saveMsgList);
      this.saveMethods(this.saveMsgList);
    },
    extractUniqueSaleIds(data) {
      const saleIds = new Set();
      (data || []).forEach((campaign) => {
        (campaign.adsets || []).forEach((adset) => {
          (adset.ads || []).forEach((ad) => {
            if (ad.adcreative && ad.adcreative.saleId !== undefined) {
              saleIds.add(ad.adcreative.saleId);
            }
          });
        });
      });
      return Array.from(saleIds);
    },
    async handelSaleSearch(ids) {
      console.log('handelSaleSearch', ids);
      if (!ids) return;
      this.$showLoading();
      const res = await saleSearch({ ids });
      this.$hideLoading();
      return res?.data?.content;
    },
    sure() {
      // if(this.level == 'adset'){
      //     this.saveAdset()
      // }
      // if(this.level == 'ad'){
      //     this.saveAdCreative()
      // }
      if (
        this.$refs.targeting?.statusData?.invaild_insterest &&
        this.$refs.targeting.statusData.invaild_insterest.length > 0
      ) {
        this.$notify.error('存在无效的兴趣词，请删除后再操作');
        return;
      }
      this.saveList();
    },
  },
};
</script>
<style lang="scss">
.editDialog {
  .el-dialog__body,
  .el-dialog__footer {
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
.editCon {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-height: 700px;
  overflow-y: auto;
  .leftList {
    flex: 0 0 340px;
    overflow: hidden;
    max-height: 700px;
    overflow-y: auto;
  }
  .rightCon {
    flex: 1;
    padding-left: 20px;
    max-height: 700px;
    overflow-y: auto;
    padding-right: 20px;
  }
}
</style>
